import { FormItem } from "../../../../../base-data/area-building/model/form-item-interface";
// edit-task
export const TASK_ASSIGN_EDIT_TABLE: FormItem[] = [
  { text: 'TaskAssignment.No', value: "id"},
  { text: 'TaskAssignment.VendorCode', value: "vendorCode"},
  { text: 'TaskAssignment.Outsource', value: "outsource"},
  { text: 'TaskAssignment.Domain', value: "professional"},
  { text: 'TaskAssignment.Contact', value: "contact"},
  { text: 'TaskAssignment.Phone', value: "tel"},
  { text: 'TaskAssignment.Mail', value: "email"},
  { text: 'TaskAssignment.IssuedBids', value: "issuedBid/issuedTotal/issuedBidPer" },
  { text: 'TaskAssignment.BidsOverTime', value: "issuedBidOverTime/issuedBidOverTimeTotal/issuedBidOverTimePer"},
  { text: 'TaskAssignment.NotCooperateBids', value: "notCooperateBids/notCooperateBidsTotalnotCooperateBidsPer/"},
  { text: 'TaskAssignment.BidsPendingReview', value: "waitBidNumbers"},
  { text: 'TaskAssignment.Select', value: "chooseVendor"},
];

// display-task
export const TASK_ASSIGN_DISPLAY_TABLE: FormItem[] = [
  { text: 'TaskAssignment.VendorCode', value: "vendorCode"},
  { text: 'TaskAssignment.Outsource', value: "outsource"},
  { text: 'TaskAssignment.Domain', value: "professional"},
  { text: 'TaskAssignment.Contact', value: "contact"},
  { text: 'TaskAssignment.Phone', value: "tel"},
  { text: 'TaskAssignment.Mail', value: "email"},
  { text: 'TaskAssignment.IssuedBids', value: "issuedBid/issuedTotal/issuedBidPer" },
  { text: 'TaskAssignment.BidsOverTime', value: "issuedBidOverTime/issuedBidOverTimeTotal/issuedBidOverTimePer"},
  { text: 'TaskAssignment.NotCooperateBids', value: "notCooperateBids/notCooperateBidsTotalnotCooperateBidsPer/"},
  { text: 'TaskAssignment.BidsPendingReview', value: "waitBidNumbers"},
];
